import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';

export const deleteSubmissionRequest = createAction('deleteSubmissionRequest');
export const deleteSubmissionSuccess = createAction<number>('deleteSubmissionSuccess');
export const deleteSubmissionFailure = createAction('deleteSubmissionFailure');

export const deleteSubmission = (id: number) => async (dispatch: AppDispatch): Promise<void> => {
    dispatch(deleteSubmissionRequest());

    try {
        await api.delete(`admin/challengeapplications/${id}`);

        dispatch(deleteSubmissionSuccess(id));
    } catch (e) {
        handleApiErrors(dispatch, deleteSubmissionFailure, e);
    }
};
